import { data } from 'jquery';

export class CurrentUser {
    id: number;
    //fullname: string;
}

export class Userprofile {
    id: number=0;
    name: string=""
    title: string=""
    field: string=""
    safeBio: string=""
    bio: string=""
    website: string=""
    twitter: string=""
    facebook: string=""
    linkedin: string=""
    company: string=""
    showEmail: boolean=false
    showPhone: boolean=false
    timeZone: number=0
    timeZoneName: string=""
    userId: number=0
    imgurl:string=""
    email:string=""
    phoneno:string=""
    countrycode: string = ""
}
